import React, { useRef, useState, useEffect, useCallback } from 'react'
import BlogLoader from './blog-loader';
import { useInfiniteScroll } from '../../hooks/display-hooks';
import { DisplayArticle } from './blog-article';
import { BlogPostHeader } from '../../models/BlogPostHeader';
import { useTranslation, useParameters } from '../../utils';
import { PostCollections } from './utils';


export const limit = {
    resultList: 10,
    topicList: 3
}

export function DisplayError() {
    
    const {t} = useTranslation();

    return (
        <div>
            <p> {t('load-error')}</p>
        </div>
    )
}

export function DisplayNoData(){

    const {t} = useTranslation();

    return (
        <div>
            <p> {t('faulty-search')}</p>
        </div>
    )
}

export default function DisplayList( { title, loader, collection}: { title?: string, 
    collection: PostCollections,
    loader: (p: {
        skip: number;
        limit: number;
}) => Promise<DisplayArticle[]> }) {
    const { lastElementRef, data, loading, error } = useInfiniteScroll(loader, { perPage: limit.resultList }, [loader]);
    const routeParams = useParameters<{
        searchType?: "category" | "tag" | "text",
        searchText?: string,
        lang?: string,
    }>();
    return (
        <div className='topic-parent'>
            {!title?<></>:
                <div className='topic-header'>
                    <p className='topic-name' dangerouslySetInnerHTML={routeParams.searchType=="text" ? {__html:"Search Results For - " + title} : {__html: title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()}}></p>
                </div>}
            <div className={`list-wrapper post-${collection}`}>
                {data.map((post, index) => {
                    if (data.length === index + 1) {
                        return <div key={post.id} ref={lastElementRef} className='result'>
                            <DisplayArticle post={post} collection={collection}></DisplayArticle>
                        </div>
                    } else {
                        return <div className='result' key={post.id}> 
                            <DisplayArticle key={post.id} post={post} collection={collection}></DisplayArticle>
                        </div>
                    }
                })}
            </div>
            <div> {loading && <BlogLoader />}</div>
            <div> {error && <DisplayError />}</div>
        </div>
    );
}